import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/upload-icon-drag.png'


const _withScopeId = n => (_pushScopeId("data-v-1f494ffe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "el-alert el-alert--error is-light margin-top-12"
}
const _hoisted_2 = { class: "el-alert__content" }
const _hoisted_3 = { class: "el-alert__title" }
const _hoisted_4 = {
  key: 1,
  class: "upload-icon-wrapper tw-flex tw-items-center tw-gap-2"
}
const _hoisted_5 = {
  key: 2,
  class: "upload-icon-wrapper flex-row ai-c cursor-pointer"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "default-text" }, "Add attachment", -1))
const _hoisted_7 = {
  key: 3,
  class: "upload-icon-wrapper"
}
const _hoisted_8 = {
  key: 4,
  class: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-gap-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "thumbnail-wrapper"
}
const _hoisted_11 = { class: "image-slot tw-flex tw-items-center tw-justify-center" }
const _hoisted_12 = { class: "image-slot" }
const _hoisted_13 = {
  key: 0,
  class: "el-upload-list__item-actions"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "el-upload-list__item-actions--picture"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "el-upload-list__item-thumbnail tw-min-h-[60px]" }
const _hoisted_18 = {
  key: 3,
  class: "el-upload-list__item-actions--picture"
}
const _hoisted_19 = {
  key: 0,
  class: "el-upload-list__item-actions"
}
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_UploadIcon = _resolveComponent("UploadIcon")!
  const _component_Text = _resolveComponent("Text")!
  const _component_ClipIcon = _resolveComponent("ClipIcon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_ImageDynamicLayout = _resolveComponent("ImageDynamicLayout")!
  const _component_PdfIcon = _resolveComponent("PdfIcon")!
  const _component_DocumentIcon = _resolveComponent("DocumentIcon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.formEntity,
    class: "attachments-form",
    "label-position": "top",
    size: "small",
    inline: false,
    ref: "attachmentsForm"
  }, {
    default: _withCtx(() => [
      (_ctx.failedUpload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, "File type ." + _toDisplayString(_ctx.fileExtention) + " not allowed.", 1),
              _createVNode(_component_v_icon, {
                onClick: _ctx.onClickCloseError,
                class: "el-icon el-alert__close-btn",
                size: 15
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-close")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.failedLargeUpload)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 1,
            class: "margin-top-12",
            title: "File size is too large.",
            type: "error"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, { label: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_upload, {
            onClick: _ctx.onClickCloseError,
            disabled: !_ctx.allowMultiple && _ctx.fileList.length === 1,
            class: _normalizeClass(["iknowa-upload tw-w-full", _ctx.uploadContainerClass]),
            action: _ctx.actionUrl,
            headers: _ctx.uploadHeaders,
            "list-type": _ctx.listType,
            "on-error": _ctx.handleErrorFiles,
            "on-success": _ctx.updateFileOnSuccess,
            "on-progress": _ctx.onProgressUpload,
            "before-upload": _ctx.onBeforeUpload,
            "file-list": _ctx.fileList,
            "show-file-list": _ctx.showFileList,
            "on-remove": _ctx.handleRemoveFile,
            multiple: _ctx.allowMultiple,
            "http-request": _ctx.httpRequest,
            limit: _ctx.allowMultiple ? '' : 1,
            accept: _ctx.accept,
            drag: ""
          }, _createSlots({
            default: _withCtx(() => [
              (_ctx.listType && !_ctx.useCustomUploadIcon && !_ctx.useDragTrigger)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    icon: "mdi-plus"
                  }))
                : _createCommentVNode("", true),
              (_ctx.useCustomUploadIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_UploadIcon),
                    _createVNode(_component_Text, {
                      variant: "p",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Upload Attachment")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.useClipUploadIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_ClipIcon),
                    _hoisted_6
                  ]))
                : _createCommentVNode("", true),
              (_ctx.userEmptyAvatarIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_UploadIcon)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.useCustomUploadIcon && _ctx.useDragTrigger)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Text, {
                      variant: "span",
                      textWeight: "400",
                      textColor: "rgba(128, 130, 159, 1)"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Drag and drop documents, or "),
                        _createVNode(_component_Text, { variant: "span" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Browse")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (_ctx.listType)
              ? {
                  name: "file",
                  fn: _withCtx(({ file }) => [
                    (_ctx.fileIsImage(file))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_ImageDynamicLayout, {
                            isLoading: file.isLoading,
                            isDeleting: file.isDeleting,
                            file: file,
                            uploadDone: _ctx.isFileUpload,
                            currentNumber: _ctx.fileUploadPercentage,
                            style: {"position":"relative"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_image, {
                                fit: "cover",
                                class: "el-upload-list__item-thumbnail",
                                src: file.src
                              }, {
                                placeholder: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_v_progress_circular, {
                                      class: "!tw-w-[30px] !tw-h-[30px]",
                                      color: "primary",
                                      indeterminate: ""
                                    })
                                  ])
                                ]),
                                error: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_v_icon, { icon: "mdi-image-remove" })
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["src"]),
                              (!file.isDeleting && _ctx.listType !== _ctx.PICTURE)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                    _createElementVNode("span", {
                                      class: "el-upload-list__item-delete",
                                      onClick: ($event: any) => (_ctx.handleRemoveFile(file))
                                    }, [
                                      _createVNode(_component_TrashIcon)
                                    ], 8, _hoisted_14)
                                  ]))
                                : _createCommentVNode("", true),
                              (!file.isDeleting && _ctx.listType === _ctx.PICTURE)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                    _createVNode(_component_v_icon, {
                                      onClick: ($event: any) => (_ctx.handleRemoveFile(file)),
                                      icon: "mdi-close-circle",
                                      size: "small"
                                    }, null, 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["isLoading", "isDeleting", "file", "uploadDone", "currentNumber"])
                        ]))
                      : (!_ctx.fileIsImage(file))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_ImageDynamicLayout, {
                              isLoading: file.isLoading,
                              isDeleting: file.isDeleting,
                              file: file,
                              uploadDone: _ctx.isFileUpload,
                              currentNumber: _ctx.fileUploadPercentage,
                              style: {"position":"relative"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_17, [
                                  (file.raw.type === 'video/mp4')
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        icon: "mdi-file-video",
                                        color: "#264FD5"
                                      }))
                                    : (file.raw.type === 'application/pdf')
                                      ? (_openBlock(), _createBlock(_component_PdfIcon, { key: 1 }))
                                      : (_openBlock(), _createBlock(_component_DocumentIcon, { key: 2 })),
                                  (!file.isDeleting && _ctx.listType === _ctx.PICTURE)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                        _createVNode(_component_v_icon, {
                                          onClick: ($event: any) => (_ctx.handleRemoveFile(file)),
                                          icon: "mdi-close-circle",
                                          size: "small"
                                        }, null, 8, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (!file.isDeleting)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                      _createElementVNode("span", {
                                        class: "el-upload-list__item-delete",
                                        onClick: ($event: any) => (_ctx.handleRemoveFile(file))
                                      }, [
                                        _createVNode(_component_v_icon, {
                                          icon: "mdi-delete-empty",
                                          size: "small"
                                        })
                                      ], 8, _hoisted_20)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["isLoading", "isDeleting", "file", "uploadDone", "currentNumber"])
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["onClick", "disabled", "class", "action", "headers", "list-type", "on-error", "on-success", "on-progress", "before-upload", "file-list", "show-file-list", "on-remove", "multiple", "http-request", "limit", "accept"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}